// TODO: move to Customize UI folder

import React, { Fragment } from 'react';
import { Field, FTBody } from '../Fuse';

export const ExitMessageOptionView = {
    DEFAULT: <FTBody><strong>Default</strong> - use the default message.</FTBody>,
    CUSTOM: <FTBody><strong>Custom</strong> - use your custom message.</FTBody>,
};

export const ExitMessageOptionField = (props) => <Field
    label="Exit Message Option"
    tooltip="Exit Message Option – Display a default or custom security message to users before they Exit Isolation."
    {...props}
/>;

export const ExitMessageTextField = (props) => <Field
    label="Exit Message"
    caption="&nbsp;(required)"
    {...props}
/>;

export const CardTitle = <Fragment>Exit Message&nbsp;<FTBody>(URL Isolation Only)</FTBody></Fragment>;
